import { createContext, useCallback, useRef, useState } from 'react';
import ChallengeModal from '../components/ChallengeModal';
import type { Challenge } from '@src/backend/src/common/types/threeds';

type ChallengeModalContextType = {
  openChallengeModal: (data: { challenge: Challenge }) => Promise<void>;
};

const ChallengeModalContext = createContext<ChallengeModalContextType>({
  openChallengeModal: () => Promise.resolve(),
});

export function ChallengeModalProvider({ children }: React.PropsWithChildren): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const [challenge, setChallenge] = useState<Challenge | null>(null);
  const resolveRef = useRef<(() => void) | null>(null);

  const close = useCallback(() => {
    setIsOpen(false);
    setChallenge(null);
    resolveRef.current?.();
    resolveRef.current = null;
  }, []);

  const openChallengeModal = useCallback((data: { challenge: Challenge }): Promise<void> => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setChallenge(data.challenge);
      setIsOpen(true);
    });
  }, []);

  return (
    <ChallengeModalContext.Provider value={{ openChallengeModal }}>
      {children}
      <ChallengeModal isOpen={isOpen} challenge={challenge} onClose={close} />
    </ChallengeModalContext.Provider>
  );
}

export default ChallengeModalContext;
